import React from "react";
import { useNavigate } from "react-router";
import { Empty } from "common/components/Empty";
import { Button } from "common/components/Button";
import { useAppTracking } from "common/hooks/storeHooks";

interface NotFoundProps {
  showHomeAction?: boolean;
}

export const NotFound: React.FC<NotFoundProps> = ({ showHomeAction = true }) => {
  const navigate = useNavigate();
  const dvhSupported = CSS.supports("(height: 100dvh)");
  const { Track } = useAppTracking({ category: "Permissions Error Page" });

  return (
    <Track>
      <div className={`w-screen ${dvhSupported ? "h-[100dvh]" : "h-screen"} flex justify-center items-center`}>
        <Empty title="404" description="The page you are looking for does not exist.">
          {showHomeAction && (
            <Button analyticsAction="not-found-home" variant="primary" onClick={() => navigate("/jobs")}>
              Take me back to the main page
            </Button>
          )}
        </Empty>
      </div>
    </Track>
  );
};
